import { render, staticRenderFns } from "./TableBank.vue?vue&type=template&id=944f12f6&scoped=true&"
import script from "./TableBank.vue?vue&type=script&lang=js&"
export * from "./TableBank.vue?vue&type=script&lang=js&"
import style0 from "./TableBank.vue?vue&type=style&index=0&id=944f12f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944f12f6",
  null
  
)

export default component.exports